import React from 'react';
import Button from 'shared/Button/Button';
import { AdviserSearchProps } from './interface/advisersInterface';

const AdviserSearch: React.FC<AdviserSearchProps> = ({ searchText, handleSearchChange, handleSearchClick }) => {
  return (
    <>
      <h1 className="text-center plum">Search Firm</h1>
      <div className="adviser-search bg-white">
        <label htmlFor="adviser-search-input" className="plum">
          FCA Number or Firm Name
        </label>
        <input
          type="search"
          value={searchText}
          onChange={handleSearchChange}
          id="adviser-search-input"
          className="form__input"
        />
        <Button className="form__submit submit-btn" label="SEARCH" onClick={handleSearchClick} disabled={!searchText} />
      </div>
    </>
  );
};

export default AdviserSearch;
